// Traduzioni italiane centralizzate. Struttura:
// - common: testi riutilizzabili (azioni, stati, parole comuni)
// - nav: voci di menu
// - enums: chiavi `form.*` usate COME VALORI in produzione (tradotte qui una sola volta)
// - <pagina>: testi specifici di ogni pagina/feature
//
// NB: le chiavi `enums.form.*` sono volutamente piatte e identiche ai valori salvati a DB
//     così `t("form.payment.cash")` funziona ovunque (vedi lib/labels.ts → formLabel).

export const it = {
  help: {
    button: "Aiuto e guide",
    title: "Centro guide",
    subtitle: "Scegli cosa vuoi imparare a fare. La guida evidenzia i punti dello schermo passo dopo passo.",
    forThisPage: "Guida per questa pagina",
    general: "Generale",
    start: "Avvia guida",
    next: "Avanti",
    prev: "Indietro",
    done: "Fine",
    navTitle: "Navigazione",
    navText: "Da qui apri il menu laterale e passi tra le sezioni: Soci, Servizi, Pagamenti, Statistiche, WhatsApp…",
    headerTitle: "Intestazione della sezione",
    headerText: "Mostra dove ti trovi. A destra trovi le azioni principali della pagina.",
    refreshTitle: "Aggiorna",
    refreshText: "Ricarica i dati della pagina con le ultime modifiche.",
    createTitle: "Crea nuovo",
    createText: "Apre il modulo per inserire un nuovo elemento in questa sezione.",
    rowMenuTitle: "Azioni sulla riga",
    rowMenuText: "Il menu ⋮ presente su ogni riga apre le operazioni disponibili: modifica, e dove previsto disabilita ed elimina.",
    helpTitle: "Centro guide",
    helpText: "Ritrovi sempre qui tutte le guide: premi questo pulsante in qualsiasi momento.",
    overviewTitle: "Panoramica dell'app",
    overviewDesc: "Come muoverti tra le sezioni e riconoscere gli elementi comuni a tutte le pagine.",
    detailsTitle: "Come funziona",
    searchTitle: "Ricerca e filtri",
    debitsFiltersTitle: "Filtra per data",
    debitsFiltersText: "Tre modalità: Periodo = un singolo mese (MM/AAAA); Anno = tutti i mesi di un anno; Personalizzato = un intervallo da data a data sul giorno del pagamento. La vista parte sempre dal periodo corrente.",
    debitsSocioTitle: "Filtra per socio",
    debitsSocioText: "Scegli un socio per vedere solo i suoi pagamenti; lascia vuoto per vederli tutti. Il campo di ricerca filtra anche per numero ricevuta.",
    sec: {
      dashboard: { title: "La Dashboard", intro: "La home riepiloga i numeri chiave del periodo (soci attivi, crediti, incassato, saldo) e dà accesso rapido alle sezioni.", details: "In alto a destra scegli il periodo: tutte le card si ricalcolano. Le scorciatoie in basso aprono direttamente Soci, Servizi, Crediti, Ricevute, Costi, WhatsApp, Debiti e Statistiche. La barra di avanzamento mostra l'incassato sul totale dovuto del periodo." },
      partners: { title: "Gestione Soci", intro: "Qui gestisci l'anagrafica dei soci: crea, modifica, disabilita o elimina un socio.", details: "Con 'Nuovo socio' apri il modulo: dati anagrafici (nome, cognome, codice fiscale), uno o più contatti (telefono, email) e il tipo socio (Proprietario, Cavallo, Pony, Altro). Dalla ⋮ di ogni riga: Modifica corregge i dati; Disabilita toglie il socio dalle selezioni operative mantenendone lo storico (è riattivabile); Elimina lo rimuove definitivamente (irreversibile). In alto cerchi per nome/cognome/CF e filtri per stato (Tutti/Attivi/Inattivi) e per tipo socio." },
      suppliers: { title: "Gestione Fornitori", intro: "Anagrafica dei fornitori: crea, modifica, disabilita o elimina un fornitore.", details: "Il modulo raccoglie ragione sociale e/o nominativo, contatti e dati utili. Dalla ⋮: Modifica, Disabilita (nasconde dalle selezioni mantenendo lo storico) ed Elimina. I fornitori vengono poi richiamati nei Costi." },
      services: { title: "Catalogo Servizi", intro: "Il catalogo dei corsi/servizi: crea, imposta prezzo e addebiti, modifica o elimina.", details: "Creando un servizio imposti nome, tipo, prezzo e frequenza di rinnovo. Se la frequenza è Mensile scegli i 'Mesi di addebito' (clicca la x su un mese per toglierlo). Indichi se il servizio è detraibile e se invia notifiche. Questi servizi alimentano gli abbonamenti (Servizi Soci) e la generazione dei crediti." },
      acqservices: { title: "Servizi Acquisiti", intro: "Il catalogo delle voci di costo dei fornitori, usato poi nei Costi.", details: "Ogni voce ha nome, descrizione, Tipo Costo/Servizio e Voce resoconto economico (entrambi a tendina con etichette leggibili), prezzo e notifica email. Quando registri un Costo, selezionando la voce questi campi si precompilano." },
      partnerServices: { title: "Servizi Soci", intro: "Associa i servizi ricorrenti ai soci, con personalizzazioni per singolo socio.", details: "Scegli socio e servizio per creare l'associazione; puoi sovrascrivere nome, descrizione, notifiche e detraibilità per quel socio. Filtra per socio o per servizio. Queste associazioni sono la base per generare i crediti mensili." },
      creditsGen: { title: "Preparazione mensili", intro: "Genera i crediti del periodo e assegna i servizi ai soci.", details: "Seleziona un servizio modello: i campi (nome, prezzo, descrizione, notifiche, detraibile) si precompilano e restano modificabili. Col + accanto a un socio aggiungi quel credito alla sua scheda del periodo selezionato; in alternativa 'Calcola' genera automaticamente i crediti del periodo dagli abbonamenti attivi. A destra l'elenco dei crediti del periodo (più recenti in alto): dalla ⋮ apri la ricevuta del socio o elimini un credito." },
      credits: { title: "Crediti", intro: "L'elenco di quanto i soci devono, per periodo.", details: "Filtra per periodo (o 'Tutti') e cerca per socio/servizio/descrizione. Ogni voce mostra socio, periodo, importo e se è detraibile. L'ordine è dal più recente. Il totale filtrato è in alto a destra. I crediti rappresentano il dovuto; i pagamenti (Debiti) li compensano." },
      debits: { title: "Pagamenti", intro: "I pagamenti ricevuti dai soci: registra un pagamento e consulta lo storico filtrabile.", details: "Con 'Registra pagamento' scegli il socio, l'importo, la data, il metodo (Contanti, Bonifico, Carta di credito, Carta di debito, Pagamento elettronico) e il periodo di competenza (MM/AAAA). Quadratura: un pagamento non può superare il credito residuo del periodo; quando il totale pagato eguaglia il credito la scheda risulta 'saldata' e viene registrata la data di saldo. La lista è ordinata dalla data di pagamento più recente; il totale dei pagamenti filtrati è in alto." },
      receipts: { title: "Ricevute", intro: "Le schede di pagamento per socio e periodo.", details: "Filtra per anno, stato (Tutte / Non saldate / Saldate), soci attivi/inattivi e tipo socio. Dalla ⋮ di ogni ricevuta: Apri la scheda, Stampa, Esporta PDF, Invia via WhatsApp, vai ai Crediti o ai Pagamenti del socio, Elimina. Aprendo la scheda registri i pagamenti (con metodo e data) e vedi crediti/competenze: la quadratura aggiorna in automatico Dovuto, Pagato, Da pagare e lo stato. 'Non saldate' mostra tutte le scoperte di qualsiasi anno." },
      costs: { title: "Costi", intro: "Le uscite del maneggio verso i fornitori.", details: "Con 'Nuovo costo' scegli Fornitore e Servizio acquisito (nome, descrizione, prezzo e tipo si precompilano), poi importo, data di pagamento, metodo e se è saldato. Filtra per anno ed esporta il PDF di riepilogo per tipologia. Dalla ⋮: Modifica o Elimina." },
      summary: { title: "Riepilogo Economico", intro: "Cruscotto del periodo e dettaglio per socio.", details: "Scheda Cruscotto: crediti totali, incassato, costi, saldo netto, tasso di incasso e numero di schede saldate/non saldate. Scheda Dettaglio per socio: ogni socio è espandibile per vedere le voci (corso ed extra); puoi espandere/chiudere tutto, stampare ed esportare il PDF, e la lista è paginata. Cambia il periodo in alto a destra." },
      statistics: { title: "Statistiche", intro: "Analisi del periodo su quattro viste.", details: "Tab Soci: riepilogo per tipo (corsi, extra, incassato) e dettaglio competenze. Tab Servizi: importi per tipo servizio. Tab Insoluti: schede non saldate per periodo, con filtro attivi/inattivi e ambito (solo periodo o periodo + precedenti). Tab Sommario: dato per singolo socio. In alto filtri per tipo socio e periodo; puoi stampare ed esportare il PDF. Le liste lunghe sono paginate." },
      waCompose: { title: "Invio messaggi WhatsApp", intro: "Prepara e accoda un invio massivo ai soci.", details: "Scegli il messaggio modello; se il template prevede un allegato generico, carica il file (PDF o immagine). Filtra i soci per tipo e stato e cercali per nome; spostali da 'Disponibili' a 'Da inviare' col + (o 'Aggiungi tutti'). I soci senza numero valido non sono selezionabili. Accodando, viene creata una voce di coda per ogni cellulare valido del socio; l'invio vero parte poi dalle Code." },
      waQueues: { title: "Code WhatsApp", intro: "Le voci pronte all'invio.", details: "'Lancia JOB invii' elabora la coda via WhatsApp rispettando la finestra di 24h. Dalla ⋮ di ogni voce: 'Rimetti in coda' (riporta in attesa e fa ripartire l'invio) o 'Elimina'. Lo stato (in attesa, inviato, fallito…) si aggiorna in tempo reale. La lista è paginata." },
      waTemplates: { title: "Template WhatsApp", intro: "I modelli di messaggio riutilizzabili.", details: "Con 'Nuovo template' imposti nome, testo del messaggio e tipo di allegato: Nessuno, Ultima ricevuta, Ricevute non pagate o Allegato generico (file caricato al momento dell'invio). Dalla ⋮: Modifica o Elimina. I template si scelgono poi in 'Invia messaggi'." },
      waMessages: { title: "Messaggi WhatsApp", intro: "Lo storico degli invii, raggruppati per destinatario.", details: "Ogni gruppo raccoglie i messaggi inviati a un socio con stato (inviato, consegnato, letto, fallito) e data. I testi lunghi sono troncati: 'Leggi tutto' apre la modale con il messaggio completo e gli allegati scaricabili. 'Reinvia' rilancia l'intero invio al socio: se la finestra 24h è chiusa parte prima il messaggio di richiesta. Filtra per stato e cerca per numero o testo." }
    },
    formTitle: "Compilazione della scheda",
    formNote: "Questa guida è solo illustrativa: non salva e non esegue alcuna operazione.",
    partnerForm: {
      active: { title: "Socio attivo", desc: "Indica se il socio è operativo. Da spento resta in archivio ma non compare nelle selezioni (crediti, invii…). È riattivabile in qualsiasi momento." },
      type: { title: "Tipo socio", desc: "Classificazione del socio: Proprietario, Cavallo, Pony o Altro. Determina raggruppamenti, filtri e statistiche." },
      name: { title: "Anagrafica", desc: "Nome e cognome (obbligatori). Sotto: nazione e comune di nascita, data di nascita e codice fiscale. Se la data di nascita indica un minorenne, compaiono in automatico le sezioni Rappresentante legale e Detraibilità." },
      residence: { title: "Residenza", desc: "Comune di residenza (compila in automatico il CAP), toponomastica (Via, Piazza…), nome della via e numero civico." },
      document: { title: "Documento", desc: "Tipo di documento (Carta d'identità, Passaporto…), identificativo, data di scadenza ed ente di rilascio." },
      email: { title: "Email", desc: "Una o più email con descrizione e tipo (Personale/Ufficio). '+ Aggiungi email' ne inserisce altre, il cestino le rimuove. La prima è la principale." },
      contacts: { title: "Contatti", desc: "Uno o più numeri con prefisso, descrizione e tipo (Cellulare/Casa/Ufficio). '+ Aggiungi contatto' ne aggiunge; il primo è il principale, usato per gli invii WhatsApp." },
      save: { title: "Salva o annulla", desc: "'Salva' registra il socio; 'Annulla' chiude senza salvare. Durante la guida non viene eseguita alcuna operazione." }
    },
    forms: {
      suppliers: "Compila i dati del fornitore: ragione sociale e/o nominativo, codice fiscale/P.IVA, contatti (telefono, email) e residenza. L'interruttore 'Attivo' lo rende operativo; da spento resta in archivio. I fornitori vengono poi richiamati nei Costi. 'Salva' registra, 'Annulla' chiude senza modifiche.",
      services: "Definisci il servizio/corso: Nome, Tipo, Prezzo e Frequenza di rinnovo. Se la frequenza è Mensile compaiono i 'Mesi di addebito' (clicca la x su un mese per toglierlo). Gli interruttori indicano se il servizio è Detraibile e se invia Notifiche. 'Salva' registra, 'Annulla' chiude.",
      acqservices: "Crea una voce di costo del fornitore: Nome, Descrizione, Tipo Costo/Servizio e Voce resoconto economico (menu a tendina con etichette leggibili), Prezzo e Notifica email. Questa voce comparirà tra i Servizi acquisiti selezionabili nei Costi.",
      partnerServices: "Associa un servizio ricorrente a un socio: scegli Socio e Servizio. Nella parte sotto puoi personalizzare per quel socio Nome, Descrizione, Notifiche e Detraibilità, sovrascrivendo i valori del servizio. 'Salva' crea o aggiorna l'associazione.",
      costs: "Registra un costo: scegli Fornitore e Servizio acquisito (Nome, Descrizione, Prezzo e Tipo si precompilano), poi Importo, Data di pagamento, Metodo e l'interruttore Saldato. 'Salva' registra il costo, 'Annulla' chiude.",
      debits: "Registra un pagamento del socio: scegli il Socio, l'Importo, il Periodo di competenza (MM/AAAA), la Data e il Metodo (Contanti, Bonifico, Carta…). Ricorda la quadratura: il pagamento non può superare il credito residuo del periodo; a pareggio la scheda risulta saldata.",
      templates: "Crea un template messaggio: Nome, Tipo di allegato (Nessuno, Ultima ricevuta, Ricevute non pagate, Allegato generico) e Testo del messaggio. Il template sarà poi selezionabile in 'Invia messaggi'. 'Salva'/'Crea' registra, 'Annulla' chiude.",
      receiptPayment: "Registra un pagamento sulla scheda: Importo (precompilato col residuo da pagare), Data del pagamento e Metodo. In fondo vedi il riepilogo Dovuto/Pagato/Residuo. Salvando, la quadratura aggiorna lo stato della scheda."
    },
    cg: {
      period: { title: "Periodo di lavoro", desc: "Scegli il mese (MM/AAAA) su cui lavorare: tutto ciò che generi o assegni qui sotto si riferisce a questo periodo." },
      calc: { title: "Calcola (generazione automatica)", desc: "Genera in automatico i crediti del periodo per tutti i soci a partire dai loro abbonamenti attivi (Servizi Soci): crea le voci mancanti e salta quelle già presenti, quindi non crea doppioni. Prima di procedere ti viene chiesta una conferma. Usalo per preparare in un colpo solo le quote ricorrenti del mese." },
      service: { title: "1) Scegli un servizio", desc: "Seleziona un servizio dal catalogo: Nome, Prezzo, Descrizione, Notifiche e Detraibilità si precompilano automaticamente dai valori di quel servizio." },
      customize: { title: "2) Personalizza i valori", desc: "Puoi sovrascrivere i valori di default solo per questa assegnazione: cambia Nome, Prezzo (€) e Descrizione senza modificare il catalogo. Nome, prezzo (> 0) e descrizione sono obbligatori per poter aggiungere il credito." },
      toggles: { title: "Notifiche e detraibilità", desc: "Attiva 'Notifiche' se il socio va avvisato e 'Deducibile' se il credito è detraibile. Partono dai valori del servizio e restano modificabili." },
      partners: { title: "3) Scegli il socio", desc: "A sinistra l'elenco dei soci attivi: usa la ricerca per trovarli rapidamente. Accanto a ciascuno c'è il pulsante + per assegnargli il servizio compilato sopra." },
      add: { title: "4) Aggiungi il credito al socio", desc: "Col + accanto al socio aggiungi alla sua scheda del periodo il credito (il dovuto) con i valori del modello. Il + è attivo solo dopo aver scelto un servizio e compilato nome, prezzo e descrizione. È un'aggiunta singola, mirata: nessun altro socio viene toccato." },
      credits: { title: "Crediti del periodo", desc: "A destra vedi i crediti già presenti per il periodo, dal più recente. L'interruttore 'Solo servizio selezionato' mostra solo quelli relativi al servizio scelto sopra." },
      rowMenu: { title: "Azioni su un credito", desc: "Dal menu ⋮ di ogni credito puoi aprire la ricevuta del socio oppure eliminare quel credito." }
    },
    rc: {
      socio: { title: "Filtra per socio", desc: "Seleziona un socio per vedere solo le sue schede; lascia vuoto per vederle tutte." },
      year: { title: "Anno", desc: "Filtra le ricevute per anno. Eccezione: con 'Non saldate' vengono mostrate tutte le scoperte di qualsiasi anno." },
      mode: { title: "Stato della scheda", desc: "Tutte, Non saldate (dovuto ancora scoperto) o Saldate. 'Non saldate' ignora l'anno e mostra ogni residuo non incassato: comodo per i solleciti." },
      active: { title: "Soci attivi / inattivi", desc: "Mostra solo i soci attivi, solo gli inattivi o tutti. I soci inattivi sono evidenziati in rosso con 🚫." },
      type: { title: "Tipo socio", desc: "Restringe a Proprietario, Cavallo o Pony." },
      rowMenu: { title: "Azioni sulla ricevuta", desc: "Dal menu ⋮: Apri la scheda (registri i pagamenti e vedi crediti/competenze; la quadratura aggiorna in automatico Dovuto, Pagato, Da pagare e lo stato), Stampa, Esporta PDF, Invia via WhatsApp, vai ai Crediti o ai Pagamenti del socio, Elimina." }
    },
    cr: {
      search: { title: "Cerca", desc: "Cerca per nominativo del socio, nome o descrizione del servizio." },
      period: { title: "Periodo", desc: "Filtra i crediti per un singolo mese (MM/AAAA) oppure scegli 'Tutti' per vederli su tutti i periodi." },
      total: { title: "Totale filtrato", desc: "La somma dei crediti attualmente filtrati: è il totale dovuto per la selezione corrente." },
      meaning: { title: "Cosa sono i crediti", desc: "Un credito è il dovuto di un socio per un servizio in un periodo. Viene compensato dai pagamenti (Pagamenti/Ricevute): quando il pagato eguaglia il dovuto la scheda risulta saldata. La lista è ordinata dal più recente; ogni voce mostra socio, periodo, importo e se è detraibile." }
    },
    st: {
      period: { title: "Periodo", desc: "Tutta l'analisi si riferisce al mese (MM/AAAA) scelto qui in alto." },
      types: { title: "Filtra per tipo socio", desc: "Limita le statistiche a Proprietario, Cavallo o Pony (oppure Tutti). Il filtro vale su tutte le tab." },
      actions: { title: "Stampa / Esporta PDF", desc: "Generano il PDF della vista corrente, in base alla tab attiva e ai filtri: 'Stampa' apre la stampa, 'Esporta PDF' apre il documento in una nuova scheda." },
      kpi: { title: "Riepiloghi", desc: "Le card in alto mostrano i totali della tab attiva e cambiano con i filtri (es. Corsi, Extra, Totale, Incassato)." },
      soci: { title: "Tab Soci", desc: "Riepilogo per tipo socio: numero e importo di Corsi ed Extra, con riga Totale. Sotto, il dettaglio delle competenze per descrizione." },
      servizi: { title: "Tab Servizi", desc: "Gli importi raggruppati per tipo di servizio: in alto le card per tipologia, sotto il dettaglio per descrizione." },
      insoluti: { title: "Tab Insoluti", desc: "Le schede non saldate. Card con totale dovuto, incassato, saldo e numero schede. Filtri extra: soci attivi/inattivi e ambito (solo periodo oppure periodo + precedenti). Sotto, l'elenco paginato con periodo, socio, scheda, scoperto e incassato." },
      sommario: { title: "Tab Sommario", desc: "Una riga per singolo socio con corso principale, corsi/extra, pagato e saldo. Lista paginata, utile per la visione d'insieme." }
    },
    wa: {
      flow: { title: "Come funzionano i messaggi", desc: "Il flusso è in 4 passi: 1) TEMPLATE — crei i modelli di messaggio riutilizzabili; 2) INVIA MESSAGGI — scegli un template e i destinatari e li accodi; 3) CODE — lanci l'invio effettivo via WhatsApp; 4) MESSAGGI — controlli l'esito (consegnato/letto/fallito) ed eventualmente reinvii." },
      compose: {
        template: { title: "1) Scegli il messaggio", desc: "Seleziona un template tra quelli creati nella sezione Template. Accanto vedi il tipo di allegato previsto dal template." },
        preview: { title: "Anteprima del testo", desc: "Il testo del messaggio in sola lettura: è esattamente ciò che riceverà il socio." },
        file: { title: "Allegato (se richiesto)", desc: "Se il template prevede un 'Allegato generico', qui carichi il file (PDF o immagine) che verrà allegato a tutti i destinatari selezionati. È obbligatorio per accodare." },
        filters: { title: "2) Filtra i soci", desc: "Restringi l'elenco per tipo socio e stato (attivi/inattivi) e cerca per nome." },
        lists: { title: "3) Scegli i destinatari", desc: "A sinistra i 'Disponibili': col + sposti un socio in 'Da inviare' (oppure 'Aggiungi tutti'); con la x lo togli. I soci senza un numero di telefono valido sono in grigio e non selezionabili." },
        enqueue: { title: "4) Accoda l'invio", desc: "Mette i messaggi in coda: viene creata una voce per ogni cellulare valido di ciascun socio scelto. L'invio vero e proprio parte poi dalla sezione Code." }
      },
      queues: {
        launch: { title: "Lancia l'invio", desc: "'Lancia JOB invii' elabora la coda e invia i messaggi via WhatsApp, rispettando la finestra di 24h. Lo stato delle voci (in attesa, inviato, fallito…) si aggiorna in tempo reale." },
        rowMenu: { title: "Azioni sulla voce", desc: "Dal menu ⋮ di ogni voce: 'Rimetti in coda' (la riporta in attesa e fa ripartire l'invio) oppure 'Elimina'." }
      },
      templates: {
        create: { title: "Nuovo template", desc: "Crea un modello riutilizzabile: Nome, Tipo di allegato (Nessuno, Ultima ricevuta, Ricevute non pagate, Allegato generico) e Testo. Il '?' dentro la finestra spiega ogni campo nel dettaglio." },
        rowMenu: { title: "Modifica o elimina", desc: "Dal menu ⋮ (o dalle icone matita/cestino su desktop) puoi modificare o eliminare un template esistente." }
      },
      messages: {
        filters: { title: "Filtri", desc: "Cerca per numero o testo e filtra per stato (inviato, consegnato, letto, in attesa, fallito). A destra i contatori di consegnati e falliti." },
        list: { title: "Storico per destinatario", desc: "Ogni blocco raggruppa i messaggi inviati a un socio, con stato e data di ciascun messaggio (testo ed eventuali allegati)." },
        readmore: { title: "Leggi tutto", desc: "I testi lunghi sono troncati: 'Leggi tutto' apre una finestra con il messaggio completo e gli allegati scaricabili." },
        resend: { title: "Reinvia", desc: "Rilancia l'intero invio a quel socio. Se la finestra di 24h è chiusa, parte prima un messaggio di richiesta e l'invio riparte appena il socio risponde." }
      }
    },
    rd: {
      intro: { title: "Scheda ricevuta", desc: "La scheda di pagamento di un socio per un periodo: qui registri i pagamenti, vedi le competenze e gestisci la ricevuta." },
      summary: { title: "Riepilogo", desc: "Periodo, Dovuto (somma dei crediti), Pagato (somma dei pagamenti), Da pagare (residuo) e Stato. Tutto si aggiorna automaticamente ad ogni pagamento (quadratura): quando Pagato eguaglia il Dovuto la scheda risulta Saldata." },
      payments: { title: "Pagamenti ricevuti", desc: "L'elenco dei pagamenti registrati per questa scheda, con data, metodo e importo. Dal menu ⋮ puoi modificare o eliminare un pagamento." },
      payAdd: { title: "Registra pagamento", desc: "Apre la finestra per inserire un pagamento (importo, data, metodo). Il pagamento non può superare il residuo da pagare; il '?' dentro la finestra spiega ogni campo." },
      competences: { title: "Competenze (crediti)", desc: "Le voci di credito del periodo per questo socio (corso ed extra) con importo. È il dettaglio di ciò che compone il Dovuto." },
      actions: { title: "Azioni sulla scheda", desc: "In alto: Indietro (torna all'elenco), Stampa, Esporta PDF e Invia via WhatsApp la ricevuta al socio." }
    },
    user: {
      intro: { title: "Profilo utente", desc: "I dati del tuo account (nome, email, ruoli). Da qui controlli con quale utenza sei collegato. La lingua e il logout si trovano nel menu in basso nella barra laterale." }
    },
    sm: {
      period: { title: "Periodo", desc: "Tutti i numeri del riepilogo si riferiscono al mese (MM/AAAA) scelto qui in alto." },
      dashboard: { title: "Cruscotto", desc: "La vista d'insieme del periodo: le card mostrano Crediti totali (dovuto), Incassato, Costi e Saldo netto. La barra 'Tasso di incasso' indica quanto è stato incassato sul totale dovuto. In basso il dettaglio ricevute: schede saldate, non saldate e totale, con il saldo netto del periodo." },
      detail: { title: "Dettaglio per socio", desc: "L'elenco dei soci con il dovuto del periodo. Filtra per singolo socio o per tipo socio. Clicca una riga (o usa 'Espandi tutto') per vedere le voci del socio (corso ed extra). Puoi Stampare ed Esportare il PDF del riepilogo. In fondo trovi il conteggio dei soci e il totale; la lista è paginata." }
    }
  },
  versions: {
    title: "Versioni",
    frontend: "Frontend",
    build: "Build",
    services: "Servizi",
    ok: "online",
    ko: "offline",
    unavailable: "Elenco versioni non disponibile"
  },
  common: {
    loading: "Caricamento...",
    error: "Si è verificato un errore",
    refresh: "Aggiorna",
    rowsPerPage: "Righe per pagina:",
    sessionExpired: "Sessione scaduta. Tra qualche istante verrai reindirizzato al login…",
    newVersionAvailable: "È disponibile una nuova versione",
    updateNow: "Aggiorna",
    save: "Salva",
    saved: "Salvato",
    cancel: "Annulla",
    delete: "Elimina",
    deleted: "Eliminato",
    edit: "Modifica",
    add: "Aggiungi",
    new: "Nuovo",
    search: "Cerca",
    filter: "Filtra",
    active: "Attivo",
    inactive: "Inattivo",
    activeF: "Non attivo",
    settled: "Saldato",
    pending: "In sospeso",
    all: "Tutti",
    emptyTitle: "Nessun elemento",
    emptyDescription: "Non ci sono dati da visualizzare.",
    openNavMenu: "Apri menu di navigazione",
    toggleNavMenu: "Comprimi o espandi il menu laterale",
    yes: "Sì",
    no: "No",
    confirm: "Conferma",
    close: "Chiudi",
    back: "Indietro",
    next: "Avanti",
    export: "Esporta",
    exportPdf: "Esporta PDF",
    print: "Stampa",
    pdf: "PDF",
    open: "Apri",
    actions: "Azioni",
    noData: "Nessun dato",
    total: "Totale",
    amount: "Importo",
    date: "Data",
    period: "Periodo",
    year: "Anno",
    status: "Stato",
    notes: "Note",
    name: "Nome",
    description: "Descrizione",
    saving: "Salvataggio...",
    deleteConfirm: "Sei sicuro di voler eliminare questo elemento?",
    requiredField: "Campo obbligatorio",
    confirmDeleteTitle: "Conferma eliminazione",
    pageInProgress: "Pagina in fase di implementazione nella v2.",
    language: "Lingua",
    italian: "Italiano",
    english: "Inglese"
  },

  sidebar: {
    brand: "Kappa Equestre",
    brandSubtitle: "Gestione Maneggio",
    groupRegistry: "Anagrafica",
    groupFinance: "Finanza",
    groupMembers: "Soci",
    groupSuppliers: "Fornitori e costi",
    groupCommunications: "Comunicazioni",
    dashboard: "Dashboard",
    composeWa: "Invia messaggi",
    queuesWa: "Code WA",
    templatesWa: "Template WA",
    messagesWa: "Messaggi WA",
    profile: "Profilo",
    manager: "Gestore"
  },

  nav: {
    home: "Home",
    partners: "Soci",
    suppliers: "Fornitori",
    services: "Corsi/extra",
    acquiredServices: "Servizi Acquisiti",
    partnerServices: "Quote Periodiche",
    credits: "Crediti",
    creditsGenerate: "Preparazione mensili",
    debits: "Storia pagamenti",
    receipts: "Ricevute",
    costs: "Costi",
    summary: "Riepilogo",
    statistics: "Statistiche",
    whatsapp: "WhatsApp",
    queues: "Code",
    templates: "Template",
    messages: "Messaggi",
    users: "Utente",
    logout: "Esci"
  },

  // Chiavi i18n usate come valori in produzione (form.*)
  form: {
    payment: {
      cash: "Contanti",
      bankTransfer: "Bonifico",
      pos: "POS",
      // Vecchi record carta/bancomat: mostrati come POS (metodo unificato).
      creditCard: "POS",
      debitCard: "POS",
      electronicPayment: "Pagamento elettronico"
    },
    partnerType: {
      pony: "Pony",
      horse: "Cavallo",
      owner: "Proprietario",
      other: "Altro"
    },
    service: {
      pony: "Pony",
      horse: "Cavallo",
      owner: "Proprietario",
      other: "Altro",
      costs: {
        institutional: "Costi istituzionali",
        commercial: "Costi commerciali",
        promiscuous: "Costi promiscui",
        other: "Altri costi"
      },
      acquired: {
        generic1: "Per assistenza cavalli",
        generic2: "Per servizi",
        generic3: "Per il personale",
        generic4: "Altre spese istituzionali",
        generic5: "Spese straordinarie",
        generic6: "Altro"
      }
    },
    paymentFrequency: {
      mothly_fee: "Mensile",
      weekly_fee: "Settimanale",
      yearly_fee: "Annuale",
      one_time_fee: "Una tantum",
      no_fee: "Gratuito"
    },
    month: {
      january: "Gennaio", february: "Febbraio", march: "Marzo", april: "Aprile",
      may: "Maggio", june: "Giugno", july: "Luglio", august: "Agosto",
      september: "Settembre", october: "Ottobre", november: "Novembre", december: "Dicembre"
    },
    whatsapp: {
      none: "Nessuno",
      lastReceipt: "Ultima ricevuta",
      lastUnpaidReceipts: "Ricevute non pagate",
      receiptPaid: "Ricevuta saldata (invio singolo)",
      receiptUnpaid: "Scheda di incasso (invio singolo)",
      genericAttachment: "Allegato",
      pending: "In attesa",
      processing: "In elaborazione",
      sent: "Inviato",
      delivered: "Consegnato",
      read: "Letto",
      failed: "Fallito"
    },
    streettype: {
      street: "Via", boulevard: "Viale", avenue: "Corso",
      square: "Piazza", plaza: "Largo", alley: "Vicolo",
      road: "Strada", esplanade: "Piazzale"
    },
    relationship: {
      father: "Padre", mother: "Madre", other: "Altro",
      parent1: "Genitore 1", parent2: "Genitore 2", legal_guardian: "Tutore legale"
    },
    numberType: { cell: "Cellulare", home: "Casa", office: "Ufficio" },
    emailType: { personal: "Personale", office: "Ufficio" },
    documentType: {
      identity_card: "Carta d'identità",
      electronic_identity_card: "Carta d'identità elettronica",
      passport: "Passaporto",
      driving_license: "Patente di guida",
      residence_permit: "Permesso di soggiorno",
      health_card_with_photo: "Tessera sanitaria con foto"
    }
  },

  home: {
    title: "Dashboard",
    currentPeriod: "Periodo corrente: {{period}}",
    activePartners: "Soci attivi",
    activePartnersSub: "iscritti al maneggio",
    creditsPeriod: "Crediti periodo",
    creditsPeriodSub: "da incassare",
    collected: "Incassato",
    collectedSub: "pagamenti ricevuti",
    balance: "Saldo",
    balanceSub: "crediti − debiti",
    incomePeriod: "Incasso periodo",
    settledLabel: "Saldato: {{count}}",
    unsettledLabel: "In sospeso: {{count}}",
    quickAccess: "Accesso rapido",
    links: {
      partnersDesc: "Gestisci i soci del maneggio",
      servicesDesc: "Catalogo dei servizi",
      creditsDesc: "Importi da incassare",
      receiptsDesc: "Storico ricevute",
      costsDesc: "Spese del maneggio",
      whatsappDesc: "Campagne messaggi",
      composeWaDesc: "Invia messaggi WhatsApp ai soci",
      messagesWaDesc: "Storico dei messaggi inviati",
      queuesWaDesc: "Code di invio WhatsApp",
      templatesWaDesc: "Modelli di messaggi",
      debitsDesc: "Storia dei pagamenti ricevuti",
      statisticsDesc: "Report e analisi",
      summaryDesc: "Riepilogo economico del periodo",
      creditsGenerateDesc: "Genera le ricevute del mese",
      partnerServicesDesc: "Quote ricorrenti dei soci"
    }
  },

  partners: {
    title: "Soci",
    subtitle: "Gestione dei soci del maneggio — {{count}} soci",
    newPartner: "Nuovo socio",
    searchPlaceholder: "Cerca per nome, cognome o codice fiscale...",
    type: "Tipo",
    contact: "Contatto",
    socio: "Socio",
    noneFound: "Nessun socio trovato",
    noneFoundDesc: "Modifica i filtri o aggiungi un nuovo socio.",
    addPartner: "Aggiungi socio",
    deleteConfirm: "Eliminare il socio {{name}}?",
    searchFilterPlaceholder: "Cerca per nome, cognome o CF...",
    typeFilter: "Tipo socio",
    allTypes: "Tutti i tipi",
    activeToggleAll: "Tutti",
    activeToggleActive: "Attivi",
    activeToggleInactive: "Inattivi",
    actions: {
      edit: "Modifica",
      editDesc: "Apri la scheda e aggiorna i dati anagrafici del socio.",
      enroll: "Servizi e pagamento",
      enrollDesc: "Iscrizione guidata: servizi ricorrenti, scheda del mese e pagamento.",
      credits: "Crediti del socio",
      creditsDesc: "Vai ai crediti (quote dovute) di questo socio.",
      payments: "Pagamenti del socio",
      paymentsDesc: "Vai ai pagamenti registrati per questo socio.",
      receipts: "Ricevute del socio",
      receiptsDesc: "Vai alle schede/ricevute di questo socio.",
      services: "Servizi del socio",
      servicesDesc: "Gestisci gli abbonamenti/servizi ricorrenti del socio.",
      activate: "Attiva socio",
      activateDesc: "Ripristina il socio come operativo nel maneggio.",
      deactivate: "Disattiva socio",
      deactivateDesc: "Il socio non comparirà più nelle selezioni operative fino a riattivazione.",
      delete: "Elimina",
      deleteDesc: "Rimuove definitivamente il record dall'anagrafica (irreversibile)."
    }
  },

  enrollment: {
    title: "Iscrizione — {{name}}",
    steps: { partner: "Anagrafica", services: "Servizi ricorrenti", sheet: "Scheda del mese", payment: "Pagamento" },
    servicesIntro: "Aggancia al socio i servizi ricorrenti (quote periodiche). Puoi saltare questo passo con Avanti.",
    serviceLabel: "Servizio ricorrente",
    noServices: "Nessun servizio ricorrente agganciato.",
    removeServiceConfirm: "Rimuovere il servizio {{name}} dal socio?",
    sheetIntro: "Scegli il mese e prepara la scheda: le quote dei servizi ricorrenti vengono addebitate in automatico. Poi puoi modificarle o aggiungere altre competenze.",
    prepare: "Prepara scheda",
    prepared: "Scheda preparata: {{count}} competenze aggiunte.",
    nothingGenerated: "Nessuna nuova quota ricorrente per questo mese: aggiungi le competenze a mano se servono.",
    noCompetences: "Nessuna competenza per questo mese.",
    paymentIntro: "Registra l'incasso della scheda di {{period}}.",
    nothingToPay: "Nessun importo da incassare per questo mese.",
    paymentSaved: "Pagamento registrato.",
    openReceipt: "Apri scheda",
    finish: "Fine"
  },

  partnerForm: {
    titleEdit: "Modifica Socio {{mode}}",
    titleNew: "Nuovo Socio {{mode}}",
    adult: "MAGGIORENNE",
    minor: "MINORENNE",
    min2: "Almeno 2 caratteri",
    required: "Obbligatorio",
    invalidEmail: "Email non valida",
    firstName: "Nome",
    lastName: "Cognome",
    partnerType: "Tipo socio",
    fiscalCode: "Codice fiscale",
    birthCountry: "Nazione di nascita",
    birthCountryIso: "Nazione di nascita (ISO3)",
    birthCity: "Comune di nascita",
    birthCityIstat: "Comune di nascita (cod. ISTAT)",
    birthDate: "Data di nascita",
    sectionResidence: "Residenza",
    residenceCity: "Comune di residenza",
    residenceCityIstat: "Comune di residenza (cod. ISTAT)",
    cap: "CAP",
    streetType: "Toponomastica",
    residenceName: "Nome residenza",
    civic: "Numero civico",
    sectionDocument: "Documento",
    documentType: "Tipo documento",
    documentId: "Identificativo documento",
    expiryDate: "Data scadenza",
    releasedBy: "Rilasciato da",
    sectionLegalRep: "Legale rappresentante",
    relationship: "Parentela",
    sectionDeduction: "Detrazione",
    sectionEmail: "Email",
    addEmail: "Aggiungi email",
    emailLabel: "Email",
    emailDescription: "Descrizione email",
    emailType: "Tipo email",
    sectionContacts: "Contatti",
    addContact: "Aggiungi contatto",
    phoneNumber: "Numero di telefono",
    phoneDescription: "Descrizione",
    phoneType: "Tipo numero",
    saveChanges: "Salva modifiche",
    lookupError: "Lookup indirizzi non disponibile. Puoi comunque inserire i codici manualmente."
  },

  receipts: {
    title: "Ricevute",
    subtitle: "Schede di pagamento per socio e periodo",
    socio: "Socio",
    statusPartner: "Stato socio",
    typePartner: "Tipo socio",
    unpaid: "Non saldate",
    paid: "Saldate",
    allReceipts: "Tutte",
    activePartners: "Attivi",
    inactivePartners: "Non attivi",
    allPartners: "Tutti i soci",
    due: "Dovuto",
    paidAmount: "Pagato",
    settled: "Saldata",
    lastPayment: "Ultimo pagamento",
    none: "Nessuna ricevuta",
    noneDesc: "Modifica i filtri per vedere altre schede.",
    deleteConfirm: "Eliminare la ricevuta #{{number}}? Verranno rimossi anche i crediti e i pagamenti del periodo.",
    actions: {
      open: "Apri scheda",
      openDesc: "Dettaglio e registrazione pagamenti",
      print: "Stampa ricevuta",
      printDesc: "Invia la ricevuta alla stampante",
      pdf: "Esporta PDF",
      pdfDesc: "Apri la ricevuta in formato PDF",
      whatsapp: "Invia via WhatsApp",
      whatsappDesc: "Invia la ricevuta al socio su WhatsApp",
      credits: "Crediti del socio",
      creditsDesc: "Vai ai crediti di questo socio",
      debits: "Pagamenti del socio",
      debitsDesc: "Vai ai pagamenti di questo socio",
      delete: "Elimina",
      deleteDesc: "Elimina definitivamente la ricevuta"
    },
    wa: {
      confirmTitle: "Invio ricevuta",
      confirmSend: "Invia",
      confirm: "Inviare a {{name}} il documento del periodo {{period}} via WhatsApp?",
      sent: "Ricevuta inviata via WhatsApp",
      window: "Finestra chiusa: inviato prima il messaggio di richiesta. La ricevuta partirà appena il socio risponde.",
      queued: "Ricevuta accodata: invio in corso",
      noPhone: "Il socio non ha un numero WhatsApp valido"
    }
  },

  receiptDetail: {
    title: "Scheda ricevuta",
    titleWithNumber: "Scheda ricevuta N° {{number}}",
    subtitle: "{{name}} — periodo {{period}}",
    subtitlePeriod: "Periodo {{period}}",
    due: "Dovuto",
    paid: "Pagato",
    toPay: "Da pagare",
    headerLabel: "Intestatario",
    paymentsTitle: "Pagamenti ricevuti — {{amount}}",
    registerPayment: "Registra pagamento",
    editPayment: "Modifica pagamento",
    noPayments: "Nessun pagamento",
    method: "Metodo",
    receiptNumber: "N. ricevuta",
    competencesTitle: "Competenze — {{amount}}",
    addCompetence: "Aggiungi competenza",
    fromSubscription: "Da abbonamento",
    noCompetences: "Nessuna competenza",
    manageCompetences: "Gestisci competenze",
    manageCompetencesDesc: "Vai ai crediti del socio per il periodo",
    managePayments: "Gestisci pagamenti",
    managePaymentsDesc: "Vai ai pagamenti del socio per il periodo",
    deleteCompetence: "Elimina la competenza",
    paymentMethod: "Metodo pagamento",
    paymentDate: "Data pagamento",
    summary: "Dovuto {{due}} · Pagato {{paid}} · Residuo {{remaining}}",
    deletePaymentConfirm: "Eliminare il pagamento di {{amount}}?",
    deleteCompetenceConfirm: 'Eliminare la competenza "{{name}}"?',
    editAction: "Modifica",
    editActionDesc: "Modifica il pagamento",
    deleteAction: "Elimina",
    deletePaymentDesc: "Elimina il pagamento"
  },

  debits: {
    title: "Storia pagamenti",
    subtitle: "Pagamenti ricevuti dai soci",
    register: "Registra pagamento",
    searchPlaceholder: "Cerca per socio...",
    socio: "Socio",
    method: "Metodo",
    receiptNumber: "N. ricevuta",
    dateCol: "Data e ora",
    none: "Nessun pagamento",
    noneDesc: "Registra il primo pagamento.",
    deleteConfirm: "Eliminare il pagamento di {{name}}?",
    filteredSingle: "Vista filtrata per un singolo socio{{name}}.",
    showAll: "Mostra tutti",
    filterPeriod: "Periodo",
    filterYear: "Anno",
    filterCustom: "Personalizzato",
    dateFrom: "Dal",
    dateTo: "Al",
    allPartners: "Tutti i soci",
    form: {
      memberRequired: "Seleziona un socio",
      amountRequired: "Importo obbligatorio",
      periodRequired: "Periodo obbligatorio",
      dateRequired: "Data pagamento obbligatoria",
      memberLabel: "Socio *",
      amountLabel: "Importo (€) *",
      periodLabel: "Periodo (MM/YYYY) *",
      periodPlaceholder: "es. 01/2025",
      dateLabel: "Data pagamento *",
      methodLabel: "Metodo pagamento",
      submit: "Registra"
    }
  },

  creditsGen: {
    title: "Preparazione mensili",
    subtitle: "Genera le ricevute del periodo e assegna i servizi ai soci",
    calculate: "Calcola",
    calculateConfirm: "Generare i servizi periodici per il periodo {{period}}? I servizi già presenti non verranno duplicati (i soci con più abbonamenti dello stesso servizio ricevono comunque la quantità corretta).",
    calcResult: "Generati {{created}} · saltati {{skipped}} · soci coinvolti {{affected}}",
    serviceTemplate: "Modello servizio da assegnare",
    selectService: "Servizio",
    notifications: "Notifiche",
    deductible: "Deducibile",
    nameLabel: "Nome servizio",
    priceLabel: "Prezzo (€)",
    descriptionLabel: "Descrizione servizio",
    nameError: "Nome non valido",
    priceError: "Inserisci un importo diverso da zero (i negativi sono ammessi come sconto)",
    descriptionError: "Descrizione non valida",
    templateHint: "Seleziona un servizio e completa i campi: poi usa ＋ accanto al socio per aggiungerlo alla sua ricevuta del periodo.",
    activePartners: "Soci",
    searchPartner: "Cerca socio...",
    addToPartner: "Aggiungi alla ricevuta del socio",
    typeSocio: "Tipo Socio",
    socio: "Socio",
    periodCredits: "Crediti del periodo — {{period}}",
    serviceType: "Tipo Servizio",
    fromSubscription: "Da abbonamento",
    onlySelected: "Solo servizio selezionato",
    openReceipt: "Apri ricevuta del socio",
    deleteCredit: "Elimina credito",
    deleteConfirm: 'Eliminare il credito "{{name}}" di {{partner}}?',
    noPartners: "Nessun socio attivo",
    noCredits: "Nessun credito per il periodo",
    addedToast: "Servizio aggiunto alla ricevuta di {{name}}"
  },

  credits: {
    title: "Crediti",
    subtitle: "Importi da incassare dai soci",
    searchPlaceholder: "Cerca...",
    partner: "Socio",
    deductible: "Detraibile",
    totalFiltered: "Totale filtrato:",
    filteredSingle: "Vista filtrata per un singolo socio.",
    showAll: "Mostra tutti",
    none: "Nessun credito",
    noneDesc: "Nessun credito per il periodo selezionato.",
    editTitle: "Modifica competenza",
    addTitle: "Aggiungi competenza",
    competenceLabel: "Competenza (corso/extra)",
    deleteConfirm: "Eliminare la competenza \"{{name}}\"?"
  },

  costs: {
    title: "Costi",
    subtitle: "Spese e uscite del maneggio",
    searchPlaceholder: "Cerca...",
    acquiredService: "Servizio acquisito",
    supplier: "Fornitore",
    method: "Metodo",
    settled: "Saldato",
    totalExpenses: "Totale spese:",
    register: "Nuovo costo",
    editCost: "Modifica costo",
    exportPdf: "Esporta PDF anno",
    none: "Nessun costo",
    noneDesc: "Nessuna voce di costo registrata per l'anno selezionato.",
    deleteConfirm: 'Eliminare il costo "{{name}}"?',
    editAction: "Modifica",
    editActionDesc: "Modifica i dati del costo.",
    deleteAction: "Elimina",
    deleteActionDesc: "Rimuove definitivamente il costo (irreversibile).",
    form: {
      supplierLabel: "Fornitore *",
      serviceLabel: "Servizio acquisito *",
      priceLabel: "Importo (€) *",
      dateLabel: "Data pagamento *",
      methodLabel: "Metodo di pagamento",
      settledLabel: "Saldato",
      supplierRequired: "Fornitore obbligatorio",
      serviceRequired: "Servizio acquisito obbligatorio",
      priceRequired: "Importo obbligatorio",
      submit: "Aggiungi"
    }
  },

  servicesAcquired: {
    title: "Servizi Acquisiti",
    subtitle: "Catalogo voci di costo (fornitori)",
    addItem: "Aggiungi voce",
    editItem: "Modifica voce",
    notice: "Catalogo delle voci di costo dei fornitori, referenziato dai Costi.",
    searchPlaceholder: "Cerca per nome...",
    nameCol: "Servizio acquisito",
    type: "Tipo",
    price: "Prezzo",
    none: "Nessuna voce",
    noneDesc: "Aggiungi una voce di costo al catalogo.",
    emailNotification: "Notifica email",
    form: {
      nameRequired: "Nome obbligatorio",
      typeRequired: "Tipo obbligatorio",
      genericRequired: "Tipo generico obbligatorio",
      priceRequired: "Prezzo obbligatorio",
      nameLabel: "Nome *",
      descriptionLabel: "Descrizione",
      typeLabel: "Tipo Costo/Servizio *",
      typeHelper: "",
      genericLabel: "Voce resoconto economico *",
      genericHelper: "",
      priceLabel: "Prezzo (€) *",
      submitAdd: "Aggiungi"
    },
    deleteConfirm: 'Eliminare la voce "{{name}}"?'
  },

  partnerServices: {
    title: "Quote Periodiche",
    subtitle: "Quote ricorrenti assegnate ai soci attivi, con override per singolo socio.",
    newAssociation: "Nuova quota periodica",
    editAssociation: "Modifica quota periodica",
    associateService: "Associa servizio",
    socio: "Socio",
    service: "Servizio",
    socioPlaceholder: "Filtra per socio attivo",
    servicePlaceholder: "Filtra per servizio ricorrente",
    clearFilters: "Pulisci filtri",
    noneFound: "Nessuna associazione trovata",
    noneFoundDesc: "Modifica i filtri o crea una nuova associazione socio-servizio.",
    linkedServices: "{{count}} servizi collegati",
    colDescription: "Descrizione",
    colPrice: "Prezzo",
    colNotifications: "Notifiche",
    colDeductible: "Deducibile",
    base: "Base: {{name}}",
    overrideTitle: "Override per il socio selezionato",
    nameLabel: "Nome servizio",
    descriptionLabel: "Descrizione servizio",
    notifications: "Notifiche",
    deductible: "Deducibile",
    listPrice: "Prezzo listino: {{price}}",
    noName: "Servizio senza nome",
    noDescription: "Nessuna descrizione",
    loadError: "Errore caricamento dati",
    editAction: "Modifica",
    editActionDesc: "Aggiorna override e collegamento.",
    deleteAction: "Elimina",
    deleteActionDesc: "Rimuove il servizio dal socio.",
    deleteConfirm: 'Rimuovere "{{name}}" da {{partner}}?',
    thisMember: "questo socio",
    form: {
      memberRequired: "Seleziona un socio",
      serviceRequired: "Seleziona un servizio",
      nameRequired: "Nome obbligatorio",
      descriptionRequired: "Descrizione obbligatoria"
    }
  },

  summary: {
    title: "Riepilogo Economico",
    subtitle: "Analisi finanziaria per periodo",
    noData: "Nessun dato disponibile",
    noDataDesc: "Nessun riepilogo per il periodo {{period}}.",
    totalCredits: "Crediti totali",
    toCollect: "da incassare",
    collected: "Incassato",
    paymentsReceived: "pagamenti ricevuti",
    costs: "Costi",
    periodOutflows: "uscite del periodo",
    netBalance: "Saldo netto",
    inMinusOut: "entrate − uscite",
    collectionRate: "Tasso di incasso",
    collectedOf: "Incassato {{paid}} su {{total}}",
    remaining: "Residuo: {{amount}}",
    receiptsDetail: "Dettaglio ricevute",
    settled: "Saldati",
    unsettled: "In sospeso",
    totalReceipts: "Totale ricevute",
    balance: "Saldo",
    tabDashboard: "Cruscotto",
    tabDetail: "Dettaglio per socio",
    socio: "Socio",
    partnerType: "Tipo socio",
    contact: "Contatto",
    total: "Totale",
    colType: "Tipo",
    colName: "Nome",
    colDescription: "Descrizione",
    colValue: "Valore",
    expandAll: "Espandi tutto",
    closeAll: "Chiudi tutto",
    noPartnerData: "Nessun credito per i filtri selezionati",
    peopleCount: "{{count}} soci",
    rowsPerPage: "Soci per pagina:"
  },

  stats: {
    title: "Statistiche",
    subtitle: "Analisi economica del periodo",
    all: "Tutti",
    tabSoci: "Soci",
    tabServizi: "Servizi",
    tabInsoluti: "Insoluti",
    tabSommario: "Sommario",
    partnerType: "Tipo socio",
    courses: "Corsi",
    extra: "Extra",
    collected: "Incassato",
    paid: "Pagati",
    due: "Da incassare",
    units: "Unità",
    amount: "Importo",
    quantity: "Quantità",
    serviceType: "Tipo Servizio",
    courseExtra: "Corso / Extra",
    detailTitle: "Dettaglio per servizio",
    perPartnerTitle: "Dettaglio per socio",
    socio: "Socio",
    contact: "Contatto",
    courseName: "Nome corso",
    summaryByType: "Riepilogo per tipo socio",
    totalDue: "Totale dovuto",
    balance: "A saldo",
    unsettledSheets: "Schede insolute",
    unsettledList: "Elenco schede insolute",
    allPeriods: "tutti i periodi",
    scope: "Ambito periodo",
    onlyPeriod: "Solo periodo",
    scopeYear: "Da inizio {{year}}",
    scopeOnly: "Solo {{period}}",
    scopeUntil: "Fino a {{period}}",
    periodAndPrevious: "Periodo + precedenti",
    sheetsShort: "schede",
    sheet: "N. Scheda",
    totalSheets: "Schede totali",
    total: "Totale",
    noData: "Nessun dato per il periodo",
    coursesCol: "Corso",
    extraCol: "Extra",
    paidCol: "Incassato",
    nCol: "N."
  },

  statistics: {
    title: "Statistiche",
    subtitle: "Panoramica generale del maneggio",
    totalPartners: "Soci totali",
    activePartners: "Soci attivi",
    catalogServices: "Servizi a catalogo",
    totalCredits: "Crediti totali",
    totalCosts: "Costi totali",
    avgServicePrice: "Prezzo medio servizio",
    partnersByType: "Soci per tipo",
    partnersSummary: "{{total}} totali — {{active}} attivi / {{inactive}} non attivi",
    creditsByPeriod: "Crediti per periodo",
    last6: "Ultimi 6 periodi",
    costsByCategory: "Costi per categoria",
    topCategories: "Top categorie di spesa"
  },

  suppliers: {
    title: "Fornitori",
    subtitle: "Aziende e fornitori del maneggio",
    newSupplier: "Nuovo fornitore",
    addSupplier: "Aggiungi fornitore",
    editSupplier: "Modifica fornitore",
    searchPlaceholder: "Cerca per nome o P.IVA...",
    companyName: "Ragione sociale",
    contact: "Contatto",
    vat: "P.IVA: {{value}}",
    none: "Nessun fornitore",
    actionsAria: "Azioni su {{name}}",
    fallbackName: "fornitore",
    editAction: "Modifica",
    editActionDesc: "Aggiorna ragione sociale, contatti e dati fiscali.",
    deleteAction: "Elimina",
    deleteActionDesc: "Rimuove il fornitore dall'anagrafica.",
    deleteConfirm: 'Eliminare il fornitore "{{name}}"?',
    form: {
      nameRequired: "Nome obbligatorio",
      invalidEmail: "Email non valida",
      companyLabel: "Ragione sociale *",
      vatLabel: "Partita IVA",
      phoneLabel: "Telefono",
      emailLabel: "Email"
    }
  },

  user: {
    title: "Profilo utente",
    subtitle: "Informazioni del tuo account",
    accountDetails: "Dettagli account",
    username: "Username",
    fullName: "Nome completo",
    email: "Email",
    userId: "User ID"
  },

  services: {
    title: "Corsi/extra",
    subtitle: "Catalogo dei corsi ed extra offerti",
    newService: "Nuovo servizio",
    addService: "Aggiungi servizio",
    searchPlaceholder: "Cerca servizio...",
    none: "Nessun servizio",
    colServiceCourse: "Servizio / Corso",
    type: "Tipo",
    price: "Prezzo",
    frequency: "Frequenza",
    deductible: "Detraibile",
    deductibleYes: "Detraibile",
    deductibleNo: "Non detraibile",
    editAction: "Modifica",
    editActionDesc: "Apri il modulo servizio/corso.",
    deleteAction: "Elimina",
    deleteActionDesc: "Rimuove il servizio dal catalogo.",
    actionsAria: "Azioni su {{name}}",
    editTitle: "Modifica servizio/corso: {{name}}",
    newTitle: "Nuovo servizio / corso",
    deleteConfirm: 'Eliminare il servizio "{{name}}"?',
    form: {
      nameRequired: "Nome obbligatorio",
      descriptionRequired: "Descrizione obbligatoria",
      priceRequired: "Prezzo obbligatorio",
      frequencyRequired: "Frequenza obbligatoria",
      typeRequired: "Tipo servizio obbligatorio",
      monthsRequired: "Seleziona almeno un mese di addebito/rinnovo",
      nameLabel: "Nome *",
      typeLabel: "Tipo servizio *",
      deductibleQuotaLabel: "Quota detraibile (€)",
      deductibleQuotaHelper: "Importo massimo detraibile (0 se non applicabile)",
      priceLabel: "Prezzo (€) *",
      descriptionLabel: "Descrizione *",
      frequencyLabel: "Frequenza di rinnovo *",
      monthsLabel: "Mesi di addebito",
      courseDeductible: "Corso detraibile",
      notifyDelays: "Notifica ritardi",
      extraInReport: "Extra in report"
    }
  },

  whatsapp: {
    queueStatus: {
      pending: "In attesa",
      waitingWindow: "Attesa finestra",
      running: "In corso",
      completed: "Completata",
      sent: "Inviata",
      failed: "Fallita",
      nothingToSettle: "Niente da saldare"
    },
    queues: {
      title: "Code WhatsApp",
      subtitle: "Messaggi in coda di invio",
      searchPlaceholder: "Cerca destinatario...",
      recipient: "Destinatario",
      attachment: "Allegato",
      createdAt: "Creata",
      none: "Nessuna coda",
      noneDesc: "Non ci sono messaggi in coda.",
      deleteConfirm: 'Eliminare la coda per "{{name}}"?',
      launchJob: "Lancia JOB invii",
      running: "Invio in corso…",
      dispatched: "JOB completato: {{sent}} inviati, {{failed}} falliti, {{blocked}} bloccati",
      alreadyRunning: "Un invio è già in corso",
      deleteAction: "Elimina",
      deleteActionDesc: "Rimuove la voce dalla coda (irreversibile).",
      requeueAction: "Rimetti in coda (forza)",
      requeueActionDesc: "Riporta la voce in attesa e forza subito l'invio, ignorando l'attesa di ~8h tra i prompt di apertura finestra. Utile per testare.",
      requeued: "Voce rimessa in coda: {{sent}} inviati",
      requeueRunning: "Invio già in corso: la voce è stata rimessa in lavorazione",
      rowsPerPage: "Code per pagina:"
    },
    messages: {
      title: "Messaggi WhatsApp",
      subtitle: "Log di tutti i messaggi inviati",
      searchPlaceholder: "Cerca per numero o testo...",
      recipient: "Destinatario",
      message: "Messaggio",
      sentAt: "Inviato",
      deliveredAt: "Consegnato",
      allCount: "Tutti ({{count}})",
      deliveredSummary: "✓ {{count}} consegnati",
      failedSummary: "✗ {{count}} falliti",
      none: "Nessun messaggio",
      noneDesc: "Nessun messaggio WhatsApp registrato.",
      filterSent: "Inviati",
      filterDelivered: "Consegnati",
      filterRead: "Letti",
      filterPending: "In attesa",
      filterFailed: "Falliti",
      unknownPartner: "Socio sconosciuto",
      attachment: "Allegato",
      readMore: "Leggi tutto",
      fullMessageTitle: "Messaggio completo",
      failureReason: "Motivo del fallimento",
      noFailureReason: "Motivo non disponibile",
      resend: "Reinvia",
      resendHint: "Reinvia l'intero invio a questo socio (se la finestra 24h è chiusa parte prima il messaggio di richiesta)",
      resendDone: "Reinvio avviato: {{sent}} messaggi inviati",
      resendWindow: "Finestra chiusa: inviato prima il messaggio di richiesta. Il reinvio partirà appena il socio risponde.",
      resendRunning: "Invio già in corso: la coda è stata rimessa in lavorazione",
      resendNoQueue: "Invio originale non più disponibile: impossibile reinviare"
    },
    templates: {
      title: "Template WhatsApp",
      subtitle: "Modelli di messaggi riutilizzabili",
      newTemplate: "Nuovo template",
      editTemplate: "Modifica template",
      searchPlaceholder: "Cerca template...",
      name: "Nome",
      text: "Testo",
      attachment: "Allegato",
      none: "Nessun template",
      noneDesc: "Crea il primo template per i messaggi WhatsApp.",
      nameRequired: "Nome obbligatorio",
      messageRequired: "Messaggio obbligatorio",
      nameLabel: "Nome *",
      attachmentLabel: "Allegato",
      messageLabel: "Testo del messaggio *",
      messageHelper: "Usa {{variabile}} per inserire variabili dinamiche",
      submitCreate: "Crea",
      deleteConfirm: 'Eliminare il template "{{name}}"?',
      editAction: "Modifica",
      editActionDesc: "Modifica nome, messaggio e allegato del template.",
      deleteAction: "Elimina",
      deleteActionDesc: "Rimuove definitivamente il template (irreversibile)."
    },
    compose: {
      title: "Invia messaggi",
      subtitle: "Scegli il messaggio, seleziona i soci e lancia l'invio",
      messageLabel: "Messaggio",
      attachmentType: "Tipo allegato",
      messagePreview: "Testo del messaggio",
      partnerType: "Tipo socio",
      partnerStatus: "Stato socio",
      searchName: "Filtra socio",
      available: "Disponibili",
      selected: "Da inviare",
      addAll: "Aggiungi tutti",
      removeAll: "Elimina tutti",
      enqueue: "Accoda {{count}} messaggi",
      launchJob: "Lancia JOB Messaggi in Coda",
      launchHint: "Dopo aver accodato, lancia l'invio dalla pagina Code WA.",
      enqueued: "Predisposti {{count}} messaggi da inviare",
      dispatched: "JOB lanciato: {{sent}} inviati, {{failed}} falliti, {{blocked}} bloccati (test mode: {{test}})",
      noPhone: "Numero non valido",
      noTemplate: "Seleziona prima un messaggio",
      attachmentSoon: "Gli allegati saranno disponibili a breve",
      chooseFile: "Scegli allegato",
      attachmentRequired: "Carica un allegato per questo messaggio",
      active: "Attivi",
      inactive: "Non attivi"
    }
  },

  install: {
    title: "Installa l'app",
    message: "Aggiungi Kappa Gestione alla schermata Home per aprirla come un'app: più veloce e a schermo intero.",
    action: "Installa",
    later: "Più tardi",
    iosHint: "Tocca Condividi in basso, poi \"Aggiungi alla schermata Home\"."
  },

  // Traduzione dei codici di errore di invio WhatsApp (Twilio serie 63xxx + Meta 13xxxx + comuni).
  whatsappErrors: {
    generic: "Errore di consegna WhatsApp",
    "63001": "Autenticazione del canale fallita (credenziali Twilio/WhatsApp)",
    "63002": "Mittente (From) WhatsApp non trovato",
    "63003": "Destinatario non trovato o non valido sul canale WhatsApp",
    "63005": "Contenuto del messaggio rifiutato dal canale",
    "63007": "Mittente WhatsApp non valido o non configurato",
    "63010": "Errore interno del canale Twilio: riprova",
    "63012": "Errore interno di WhatsApp/Meta: riprova",
    "63013": "Invio bloccato dalle policy di WhatsApp",
    "63016": "Messaggio fuori dalla finestra di 24 ore: serve un template approvato",
    "63017": "La finestra di conversazione 24h è chiusa",
    "63018": "Limite di frequenza superato (troppi messaggi/template): riprova più tardi",
    "63019": "Richiesta non valida (formato del messaggio)",
    "63020": "Richiesta non valida (parametri)",
    "63021": "Messaggio rifiutato da WhatsApp (numero non valido o policy)",
    "63022": "Parametri del template non validi",
    "63023": "Template non valido o non approvato",
    "63024": "Destinatario non valido: il numero non ha WhatsApp o non ha accettato i termini",
    "63025": "Operazione non consentita sul canale",
    "63026": "Contenuto/template non consentito",
    "63027": "Numero mittente WhatsApp non valido",
    "63028": "Troppe richieste: limite raggiunto",
    "63029": "Messaggio non consegnato dal canale",
    "63030": "Tipo di allegato/media non supportato",
    "63031": "Mittente e destinatario non possono coincidere",
    "63032": "Messaggio bloccato (l'utente ha bloccato il mittente o policy)",
    "63033": "Messaggio non consegnato",
    "63049": "Meta ha scelto di non consegnare questo messaggio marketing",
    "63051": "Limite di messaggi marketing per utente raggiunto",
    "63052": "Numero non valido per WhatsApp",
    "63105": "Sender WhatsApp non registrato/abilitato",
    "63112": "Account WhatsApp Business disabilitato da Meta (o verifica in corso)",
    "131000": "Errore generico di WhatsApp/Meta",
    "131026": "Messaggio non recapitabile (numero non su WhatsApp o non raggiungibile)",
    "131047": "Servono 24 ore dall'ultima risposta del socio: usa un template",
    "131049": "WhatsApp ha limitato l'invio per mantenere la qualità: riprova più tardi",
    "131051": "Tipo di messaggio non supportato",
    "131053": "Impossibile caricare il media allegato",
    "470": "Messaggio fuori dalla finestra 24h: usa un template",
    "30008": "Consegna non riuscita (errore sconosciuto)",
    "21610": "Il destinatario ha annullato l'iscrizione (ha inviato STOP)"
  }
};

export type Resources = typeof it;
